import { render, staticRenderFns } from "./_groupId.vue?vue&type=template&id=0cd2fb41&scoped=true&"
import script from "./_groupId.vue?vue&type=script&lang=js&"
export * from "./_groupId.vue?vue&type=script&lang=js&"
import style0 from "./_groupId.vue?vue&type=style&index=0&id=0cd2fb41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd2fb41",
  null
  
)

export default component.exports